import { useLazyQuery, useQuery } from "@apollo/client/react"; import React, { useEffect, useState } from "react";
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { CustomButton } from "../../../components/customButton/CustomButton";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";

import { GET_PACIENTE_PROBABLE_PAGINATED } from "../../../data/graphQL/queries/PacienteProbable/getPacienteProbablePaginated";
import { adaptPacienteProbableArray } from "../../../adapters/pacienteProbable/pacienteProbableAdapter";
import { SelectInput } from "../../../components/selectInput/SelectInput";
import { TextInput } from "../../../components/textInput/TextInput";
import { Grid } from "@mui/material";
import { GET_ALL_ESTADOS } from "../../../data/graphQL/queries/PacienteProbable/getAllEstados";
import { useDebounce } from "../../../hooks/useDebounce";
import { GET_DELEGACIONES_BY_USUARIO } from "../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario";
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { adaptDelegacionArray } from "../../../adapters/delegacionAdapter";
import { MobileContainer, DesktopOrTabletContainer } from "../../../responsiveTools/ResponsiveContainers";
import { useGetBreakpoints } from "../../../responsiveTools/breakpoints";
import { DateInput } from "../../../components/dateInput/DateInput";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { SpeedDialModal } from "../../../components/speedDialModal/SpeedDialModal";
import 'moment/locale/es';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import toast, { Toaster } from 'react-hot-toast';
import VisibilityIcon from '@mui/icons-material/Visibility';
import './pacienteProbableContent.scss';
import { MobileSwipeModal } from "../../../components/mobileSwipeModal/MobileSwipeModal";
import { useLocation, useNavigate } from 'react-router-dom';
import { adaptPrePacienteExportArray, GET_PACIENTE_PROBABLE_EXPORT } from "../../../data/graphQL/queries/PacienteProbable/getPacienteProbableExport";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import {
  Button
} from
  '@mui/material';
import { CustomChip } from "../../../components/chip/Chip";
import { PopoverModal } from "../../../components/popoverModal/PopoverModal";
import { downloadExcel } from "../../../utils/downloadExcel";

const locale = "es-ES";
const ESTADO_PENDIENTE = 1;

export const PacienteProbableContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const rutasStorage = localStorage.getItem('navigationRoutes');

  const [openFilterModal, setOpenFilterModal] = useState(false);
  const { isMobile, isDesktop } = useGetBreakpoints();
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [allowedWrite, setAllowedWrite] = useState(false);
  const [sortModel, setSortModel] = useState();

  const storageId = sessionStorage.getItem('idUsuario');

  const [getDelegacionOrigen, { data: delegacionOrigenData }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!delegacionOrigenData) return;
    if (delegacionOrigenData.usuarioFull.success) {
      const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
      sessionStorage.setItem('delegacionOrigen', deleg);
      setDelegacionOrigen(deleg);
    }
  }, [delegacionOrigenData]);

  useEffect(() => {
    getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId, 10) } });
  }, []);

  const getChipEstado = (estado) => {
    switch (estado) {
      case 1:
        return (
          <CustomChip label='Pendiente' isYellow title='Pendiente' />);

      case 2:
        return (
          <CustomChip label='A externar' isGreen title='A externar' />);

      case 3:
        return (
          <CustomChip label='Obito' isBlack title='Obito' />);

      case 4:
        return (
          <CustomChip label='Recuperado' isLightBlue title='Recuperado' />);

      case 5:
        return (
          <CustomChip label='No Viable' isRed title='No Viable' />);

      default: return;
    }
  };

  function buildNestedOrder(path, dirUpper) {
    return path.split('.').reduceRight(
      (acc, key, i, arr) => i === arr.length - 1 ? { [key]: dirUpper } : { [key]: acc },
      {}
    );
  }

  const handleSortModelChange = (model) => {
    const first = model?.[0];
    if (!first?.field || !first?.sort) {
      setOrderBy(undefined);
      return;
    }
    const col = columns.find((c) => c.field === first.field);
    const dirUpper = first.sort.toUpperCase(); // "ASC" | "DESC"

    const ob = col?.orderByPath ?
      buildNestedOrder(col.orderByPath, dirUpper) // ej. "idDelegacionNavigation.descripcion"
      : { [first.field]: dirUpper }; // plano

    setOrderBy(ob);
  };

  const handleClickAction = (previewMode, idPrePaciente) => {
    navigate('/pacienteProbable/crearPacienteProbable', {
      state: {
        idPaciente: idPrePaciente,
        previewMode
      }
    });
  };

  const initialColumns = [
    {
      field: 'action',
      headerName: '',
      minWidth: 40,
      maxWidth: 40,
      width: 40,
      flex: isDesktop ? 1.5 : null,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <PopoverModal>
            <div className='popover-modal-content'>
              {row?.idEstado == ESTADO_PENDIENTE &&
                allowedWrite &&
                <div
                  onClick={() => handleClickAction(false, row?.idPrePaciente)} aria-hidden='true'
                  className='item-option clickable-option'>

                  <EditIcon className='edit-icon' />
                  <span className='toggle-action'>Editar</span>
                </div>
              }
              <div onClick={() => handleClickAction(true, row?.idPrePaciente)} aria-hidden='true'
                className='item-option clickable-option'>

                <VisibilityIcon className='edit-icon' />
                <span className='toggle-action'>Ver</span>
              </div>
            </div>
          </PopoverModal>);

      }
    },
    {
      field: 'delegacion',
      headerName: 'Delegación',
      flex: isDesktop ? 4 : null,
      orderByPath: 'idDelegacionNavigation.descripcion',
      width: 60,
      hide: isMobile
    },
    {
      field: 'idPrePaciente',
      headerName: 'PHC',
      flex: isDesktop ? 2 : null,
      width: 60
    },
    {
      field: 'nombre',
      headerName: 'Paciente',
      flex: isDesktop ? 4 : null,
      width: 140,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return row.nombre + ' ' + row.apellido;
      }
      // valueGetter: ({ row }) => (row.nombre + ' ' + row.apellido)
    },
    {
      field: 'institucion',
      headerName: 'Institución',
      flex: isDesktop ? 5 : null,
      orderByPath: 'codInstitucionNavigation.cod_Institucion',
      width: 180
    },
    {
      field: 'programa',
      headerName: 'Programa',
      flex: isDesktop ? 2.5 : null,
      orderByPath: 'idTipoModuloNavigation.abreviacion',
      width: 70
    },
    {
      field: 'idEstado',
      headerName: 'Estado',
      headerAlign: 'center',
      align: 'center',
      flex: isDesktop ? 2.5 : null,
      width: 90,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return getChipEstado(row.idEstado);
      }
    },
    {
      field: 'fechaAlta',
      headerName: 'Fecha alta',
      flex: isDesktop ? 3.5 : null,
      width: 90,
      type: 'date'
    },
    {
      field: 'usuario',
      headerName: 'Usuario alta',
      flex: isDesktop ? 4.5 : null,
      width: 140,
      orderByPath: 'idUsuarioAltaNavigation.apellido'
    },
    {
      field: 'fechaAltaProbable',
      headerName: 'F. alta probable',
      flex: isDesktop ? 3.5 : null,
      width: 90,
      type: 'date'
    }];


  const {
    pacientesProbables,
    totalCount,
    estadosPacientes,
    allDelegaciones,
    filters,
    handleChangeFilters,
    pageReady,
    orderBy,
    setOrderBy,
    pacientesProbablesLoading
  } = useGetPacientesProbables(isMobile);

  const [getPacienteProbableExport, { data: dataExport, loading: exportLoading }] = useLazyQuery(GET_PACIENTE_PROBABLE_EXPORT);

  useEffect(() => {
    if (!dataExport) return;
    if (dataExport?.allPrePacienteExport) {
      const columns = [
        "Región",
        "Delegación",
        "Institución",
        "Nombre",
        "Apellido",
        "Tipo de Documento",
        "Numero de documento",
        "Fecha de nacimiento",
        "Sexo",
        "Teléfono Paciente",
        "Familiar Contacto",
        "Teléfono Familiar contacto",
        "Financiador",
        "Referente",
        "Programa",
        "Estado",
        "Fecha de Alta prob.",
        "Usuario Alta",
        "Fecha Alta",
        "Usuario Modificación",
        "Fecha Modificación",
        "Observaciones"];

      const dataToExport = adaptPrePacienteExportArray(dataExport?.allPrePacienteExport);

      downloadExcel({
        fileName: 'ListadoPacientesProbables',
        sheet: "PacienteProbable",
        tablePayload: {
          header: columns,
          body: dataToExport
        }
      });
      toast.success("Archivo exportado con éxito");
    }
  }, [dataExport]);

  const handleExport = () => {
    getPacienteProbableExport({
      variables: {
        where: {
          and: [
            { idEstado: { eq: filters?.selectedFilterByStatus } },
            { idDelegacion: { eq: filters?.selectedFilterByDelegacion } },
            filters?.dateFrom ?
              { or: [{ fechaAlta: { gte: filters?.dateFrom } }, { fechaAlta: { eq: null } }] } :
              {},
            filters?.dateTo ?
              { or: [{ fechaAlta: { lte: filters?.dateTo } }, { fechaAlta: { eq: null } }] } :
              {}]

        }
      }
    });
  };

  const columns = generateColumnsDefaultConfiguration(initialColumns, isMobile);

  useEffect(() => {
    setChildrenAction(() =>
      <>
        <DesktopOrTabletContainer>
          <div style={{ display: 'flex' }}>
            <CustomButton
              style={{ marginRight: 10 }}
              label={'Exportar'}
              isLoading={exportLoading}
              onClick={handleExport}
              variant={'outlined'}
              size={'medium'}>

              Exportar
            </CustomButton>
            <CustomButton
              label={'Nuevo'}
              variant={'contained'}
              size={'medium'}
              disabled={!allowedWrite}
              onClick={() => navigate('/pacienteProbable/crearPacienteProbable', {
                state: {
                  idPaciente: 0,
                  previewMode: false
                }
              })} />

          </div>
        </DesktopOrTabletContainer>
      </>
    );
  }, [exportLoading, allowedWrite, filters]);

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  const modalOptions = [
    {
      displayName: 'Nuevo',
      icon: AddCircleOutlineIcon,
      onClick: () => navigate('/pacienteProbable/crearPacienteProbable', {
        state: {
          idPaciente: 0,
          previewMode: false
        }
      })
    },
    {
      displayName: 'Descargar',
      icon: FileDownloadOutlinedIcon,
      onClick: () => handleExport()
    },
    {
      displayName: 'Filtrar',
      icon: FilterAltOutlinedIcon,
      onClick: () => setOpenFilterModal(true)
    }];

  return (
    <div className="paciente-probable-content">

      <DesktopOrTabletContainer>
        <FiltersChildren
          handleChangeFilters={handleChangeFilters}
          filters={filters}
          allDelegaciones={allDelegaciones}
          estadosPacientes={estadosPacientes}
          isMobile={isMobile} />

      </DesktopOrTabletContainer>
      <MobileContainer>
        <SpeedDialModal containerClass={'dial-paciente-probable'}>
          {modalOptions.map((option) =>
            <Button key={option.displayName} onClick={option.onClick}>
              <div className='dial-option-container'>
                <option.icon className='dial-option-icon' />
                <span className='dial-option-text'>
                  {option.displayName}
                </span>
              </div>
            </Button>
          )}
        </SpeedDialModal>
        <MobileSwipeModal
          open={openFilterModal}
          onClose={() => setOpenFilterModal(false)}
          title={'Filtro de búsqueda'}>

          <FiltersChildren
            handleChangeFilters={handleChangeFilters}
            filters={filters}
            allDelegaciones={allDelegaciones}
            estadosPacientes={estadosPacientes}
            isMobile={isMobile} />

        </MobileSwipeModal>
      </MobileContainer>
      <DataGridGenerico
        columns={columns}
        toolbar={false}
        rowsPerPage={isMobile && [25]}
        mobileTable={isMobile}
        rows={pacientesProbables}
        pageSize={filters?.paginationStatus?.pageSize}
        loading={!pageReady || pacientesProbablesLoading}
        totalCount={totalCount}
        currentPage={filters?.paginationStatus.page}
        onPageChange={(page) => {
          handleChangeFilters('paginationStatus', { ...filters.paginationStatus, page });
        }}
        onPageSizeChange={(pageSize) => {
          handleChangeFilters('paginationStatus', { ...filters.paginationStatus, pageSize });
        }}
        sortingMode="server"
        sortModel={sortModel} // estado controlado
        onSortModelChange={(m) => {
          setSortModel(m);
          handleSortModelChange(m); // acá armás orderBy y disparás la query
        }} />

    </div>);

};

const FiltersChildren = ({
  handleChangeFilters,
  filters,
  allDelegaciones,
  estadosPacientes,
  isMobile
}) => {

  const handleChangeEstadoFilter = (value) => {
    handleChangeFilters('selectedFilterByStatus', value);
    // Si el estado seleccionado es "Pendiente", limpiamos las fechas
    if (value === ESTADO_PENDIENTE) {
      handleChangeFilters('dateFrom', null);
      handleChangeFilters('dateTo', null);
    } else {
      handleChangeFilters('dateFrom', moment().subtract(1, 'month').format("YYYY-MM-DDT03:00:01.000[Z]"));
      handleChangeFilters('dateTo', moment().format("YYYY-MM-DDT23:59:59.000[Z]"));
    }
  };
  return (
    <Grid
      container
      columns={{
        xs: 1,
        sm: 5
      }}
      columnSpacing={2}
      rowGap={2}
      className='filters-grid'>

      <Grid size={{ xs: 1 }}>
        <TextInput
          label="Buscador"
          value={filters?.searchFilter}
          searchIcon
          onChange={(e) => handleChangeFilters('searchFilter', e.target.value)} />

      </Grid>
      <Grid size={{ xs: 1 }}>
        <SelectInput
          label="Delegacion"
          options={allDelegaciones}
          onChange={(e) => handleChangeFilters('selectedFilterByDelegacion', e.target.value)}
          value={filters?.selectedFilterByDelegacion || ''} />

      </Grid>
      <Grid size={{ xs: 1 }}>
        <SelectInput
          label="Estado"
          options={estadosPacientes}
          onChange={(e) => handleChangeEstadoFilter(e.target.value)}
          value={filters?.selectedFilterByStatus || ''} />

      </Grid>
      {filters?.selectedFilterByStatus !== ESTADO_PENDIENTE &&
        <>
          <Grid size={{ xs: isMobile ? 0.5 : 1 }}>
            <DateInput
              label="Desde"
              value={filters?.dateFrom}
              error={false}
              onChange={(e) => {
                handleChangeFilters('dateFrom', e != null ? moment(e).format('yyyy-MM-DDT03:00:01.000[Z]') : '');
                console.log(moment(e).format('yyyy-MM-DDT03:00:01.000[Z]'));
                
              }} />

          </Grid>
          <Grid size={{ xs: isMobile ? 0.5 : 1 }}>
            <DateInput
              label="Hasta"
              value={filters?.dateTo}
              error={false}
              onChange={(e) => handleChangeFilters('dateTo', e != null ? moment(e).format('yyyy-MM-DDT23:59:59.000[Z]') : '')} />

          </Grid>
        </>
      }
    </Grid>);

};

const useGetPacientesProbables = (isMobile) => {
  const [pacientesProbables, setPacientesProbables] = useState([]);
  const [estadosPacientes, setEstadosPacientes] = useState([]);
  const [allDelegaciones, setAllDelegaciones] = useState([]);
  const [pageReady, setPageReady] = useState(false);
  const [orderBy, setOrderBy] = useState({ idPrePaciente: 'ASC' });

  // preseteo los filtros
  const filtrosPersist = JSON.parse(localStorage.getItem('pacientesProbablesFilters'));

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      paginationStatus: { pageSize: isMobile ? 25 : 10, page: 0 },
      searchFilter: '',
      selectedFilterByStatus: filtrosPersist != null ? filtrosPersist.selectedFilterByStatus : 1,
      selectedFilterByDelegacion: filtrosPersist != null ? filtrosPersist?.selectedFilterByDelegacion : parseInt(sessionStorage.getItem('delegacionOrigen'), 10),
      dateFrom: filtrosPersist != null ? filtrosPersist.dateFrom : null,
      dateTo: filtrosPersist != null ? filtrosPersist.dateTo : null
    },
    'pacientesProbablesFilters'
  );

  const {
    paginationStatus,
    searchFilter,
    selectedFilterByDelegacion,
    selectedFilterByStatus,
    dateFrom,
    dateTo
  } = filters;
  const debouncedFilterValue = useDebounce(searchFilter, 1000);

  const [getPacientesProbables, { data: pacientesData, loading: pacientesProbablesLoading }] = useLazyQuery(GET_PACIENTE_PROBABLE_PAGINATED, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!pacientesData) return;
    setPacientesProbables(pacientesData);
  }, [pacientesData]);

  const { data: estadosData, loading: estadosLoading } = useQuery(GET_ALL_ESTADOS);

  useEffect(() => {
    if (!estadosData) return;
    setEstadosPacientes(estadosData?.allEstadosPrePaciente?.map((e) => (
      { id: e?.id, displayName: e?.nombre })
    ));
  }, [estadosData]);

  const storageId = sessionStorage.getItem('idUsuario');
  const { data: dataDelegaciones, loading: delegacionesLoading } = useQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: JSON.parse(storageId, 10) }
  });

  useEffect(() => {
    if (!dataDelegaciones) return;
    setAllDelegaciones(adaptDelegacionArray(dataDelegaciones, false))
  }, [dataDelegaciones]);

  const buildIdPrePacienteFilter = (term) => {
    const idPaciente = parseInt(term);
    if (!isNaN(idPaciente)) {
      return { idPrePaciente: { eq: idPaciente } };
    }
    return null;
  };

  // ESTO NO FUNCIONA YA QUE LAS FECHAS SON DATETIME
  // const buildDateFilter = (term, dateField) => {
  //   const date = moment(term, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);
  //   if (date.isValid()) {
  //     return { [dateField]: { eq: date.format('YYYY-MM-DD') } };
  //   }
  //   return null;
  // };

  const buildFilters = (filterValue) => {
    if (!filterValue) return null;

    // Divide el valor en palabras
    const terms = filterValue.trim().split(/\s+/);

    // Si solo hay un término, busca en todos los campos relevantes individualmente
    if (terms.length === 1) {
      return {
        or: [
          ...(buildIdPrePacienteFilter(terms[0]) ? [buildIdPrePacienteFilter(terms[0])] : []),
          { nombre: { contains: terms[0] } },
          { apellido: { contains: terms[0] } },
          { codInstitucionNavigation: { nombre: { contains: terms[0] } } },
          { codInstitucionNavigation: { cod_Institucion: { contains: terms[0] } } },
          { idTipoModuloNavigation: { abreviacion: { contains: terms[0] } } },
          { idEstadoNavigation: { nombre: { contains: terms[0] } } },
          { idUsuarioAltaNavigation: { nombre: { contains: terms[0] } } },
          { idUsuarioAltaNavigation: { apellido: { contains: terms[0] } } }],

      };
    }

    // Si hay más de un término, busca cada palabra en todos los campos relevantes sin agrupar
    return {
      or: terms.flatMap((term) => [
        ...(buildIdPrePacienteFilter(term) ? [buildIdPrePacienteFilter(term)] : []),
        { nombre: { contains: term } },
        { apellido: { contains: term } },
        { codInstitucionNavigation: { nombre: { contains: term } } },
        { codInstitucionNavigation: { cod_Institucion: { contains: term } } },
        { idTipoModuloNavigation: { abreviacion: { contains: term } } },
        { idEstadoNavigation: { nombre: { contains: term } } },
        { idUsuarioAltaNavigation: { nombre: { contains: term } } },
        { idUsuarioAltaNavigation: { apellido: { contains: term } } }]
      )
    };
  };


  useEffect(() => {
    if (!pacientesProbablesLoading) {
      
      getPacientesProbables({
        fetchPolicy: 'no-cache',
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              { idEstado: { eq: selectedFilterByStatus } },
              { idDelegacion: { eq: selectedFilterByDelegacion } },
              ...(dateFrom ? [{ or: [{ fechaAlta: { gte: dateFrom } }, { fechaAlta: { eq: null } }] }] : []),
              ...(dateTo ? [{ or: [{ fechaAlta: { lte: dateTo } }, { fechaAlta: { eq: null } }] }] : []),
              ...(debouncedFilterValue ? [buildFilters(debouncedFilterValue)] : []) // Añadimos los filtros dinámicos aquí
            ]
          },
          order: orderBy ? [orderBy] : []
        }
      });
    }
  }, [
    paginationStatus,
    debouncedFilterValue,
    selectedFilterByStatus,
    selectedFilterByDelegacion,
    dateFrom,
    dateTo,
    orderBy]
  );

  useEffect(() => {
    if (
      !pacientesProbablesLoading &&
      !delegacionesLoading &&
      !estadosLoading) {
      setPageReady(true);
    }
  }, [
    pacientesProbablesLoading,
    delegacionesLoading,
    estadosLoading]
  );

  return {
    pacientesProbables: adaptPacienteProbableArray(pacientesProbables) || [],
    totalCount: pacientesProbables?.allPrePaciente?.totalCount,
    estadosPacientes,
    allDelegaciones,
    filters,
    handleChangeFilters,
    pageReady,
    orderBy,
    setOrderBy,
    pacientesProbablesLoading
  };
};